import React from 'react';
import './nav-text.css'

const Nav = (props) => {
  return (
    <p className={props.s}>
      {props.navtext || props.navtext1}
    </p>
  );
}

export default Nav;